import React from 'react';

import Button from '../../Components/Button';
import ListGroup from '../../Components/ListGroup';

import './style.css';

const OList = ({ title, data = [], color }) => {
  return data && data.length > 0 ? (
    <React.Fragment>
      <p className={`level-container-list-title ${color}`}>{title}</p>
      <ol className="level-container-list">
        {data.map(text => {
          return (
            <li key={text} className="level-container-list-text">
              {text}
            </li>
          );
        })}
      </ol>
    </React.Fragment>
  ) : null;
};

const Level = ({
  onLevelClick,
  className,
  time,
  price,
  description,
  projects,
  outcomes,
  internship,
  benefits,
  basics,
  stack
}) => {
  return (
    <div className={` level-container ${className}`}>
      <span className="level-container-time">{time}</span>
      <p className="level-container-amount">INR {price}</p>

      <Button
        onClick={() => onLevelClick(time)}
        className="level-container-button"
        primaryFix
        text="ENROLL NOW"
      />
      {/* <p className="level-container-description">{description}</p> */}

      <OList title="Details" data={description} color="aqua-green" />
      <OList title="Stack Used" data={stack} color="medium-blue" />
      <OList title="Live Projects" data={projects} color="aqua-green" />
      <OList title="Course Outcomes" data={outcomes} color="medium-blue" />
      <OList title="Prerequisites" data={basics} color="light-purple" />
      <OList title="Internships" data={internship} color="light-pink" />
      <OList title="Extra Benefits" data={benefits} color="light-orange" />
    </div>
  );
};

const LevelGroup = ({ levels = [], linkedData = {}, onLevelClick, note }) => {
  return levels && levels.length > 0 ? (
    <ListGroup
      containerClassName="level-group-container"
      title="Courses to choose from"
      horizontal
      description={note ? `Note: ${note}` : ''}
      count={levels.length > 2 ? 3 : levels.length}>
      {levels.map(levelData => {
        const projects = linkedData[levelData.id]
          ? linkedData[levelData.id]['liveProjects'].map(item => item.name)
          : [];
        return (
          <Level
            key={levelData.name}
            time={levelData.name}
            price={
              levelData.amount > 0 ? Math.trunc(levelData.amount / 100) : 0
            }
            description={levelData.details ? [levelData.details] : []}
            projects={projects}
            stack={levelData.stackUsed}
            outcomes={levelData.outcomes}
            onLevelClick={onLevelClick}
            internship={levelData.internships}
            benefits={levelData.extraBenefits}
            basics={levelData.prerequisites}
          />
        );
      })}
    </ListGroup>
  ) : null;
};

export default LevelGroup;



// WEBPACK FOOTER //
// ./src/Pages/LiveClass/Levels.js